import React, { createContext, useContext } from 'react';

import { usePrivilegesProvider } from '../hooks/privileges';
import { useIsVerified } from '../hooks/useIsVerified';

export const usePrivileges = () => useContext(privilegesContext);

export const privilegesContext = createContext();

export const AuthProvider = ({ children }) => {
  const privileges = usePrivilegesProvider();
  useIsVerified();


  return (
    <privilegesContext.Provider value={ privileges }>
      {children}
    </privilegesContext.Provider>
  );
};
